import axios from '../../libs/axios_csrf';
import React from 'react';
import {
  Button,
  ControlLabel,
  FormGroup,
  FormControl,
  option,
} from 'react-bootstrap';
import { FieldGroup } from './FieldGroup';
import { inject, observer } from 'mobx-react';
import { injectIntl } from 'react-intl';
import { validateEmail } from './functions';

@inject('affiliationStore')
@injectIntl
@observer
export default class AffiliationForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      role: 'co_founder', //Default
      disabledButton: true,
    };
  }

  setAState(prop, value) {
    this.setState({
      [prop]: value,
    });
  }

  componentDidUpdate(prevProps, prevState) {
    let { affiliationStore } = this.props;
    let disabledButton =
      !validateEmail(this.state.email) ||
      affiliationStore.checkEmail(this.state.email);

    if (this.state.email !== prevState.email) {
      this.setAState('disabledButton', disabledButton);
    }
  }

  render() {
    let { affiliationStore, intl } = this.props;
    return (
      <form id="affiliation-form">
        <FieldGroup
          id="form-control-email"
          type="email"
          label={this.props.intl.formatMessage({ id: 'email' })}
          placeholder={this.props.intl.formatMessage({ id: 'enter_email' })}
          value={affiliationStore.formEmail}
          onChange={e => {
            affiliationStore.formEmailChange(e.target.value);
          }}
        />

        <FormGroup controlId="formControlsSelect">
          <ControlLabel>
            {this.props.intl.formatMessage({ id: 'role' })}
          </ControlLabel>
          <FormControl
            componentClass="select"
            placeholder="select"
            value={this.state.role}
            onChange={e => this.setAState('role', e.target.value)}
          >
            {affiliationStore.roles.map((e, idx) => (
              <option value={e.toString()} key={idx}>
                {this.props.intl.formatMessage({ id: e })}
              </option>
            ))}
          </FormControl>
        </FormGroup>
        <Button
          bsStyle="primary"
          disabled={affiliationStore.disabledButton}
          onClick={() => affiliationStore.sendEmail(this.state.role)}
        >
          {intl.formatMessage({ id: 'send' })}
        </Button>
      </form>
    );
  }
}
